<h2 mat-dialog-title>{{ titel }}</h2>

<mat-dialog-content class="dialog-content">

  <p class="intro">{{ beschreibung }}</p>


  <!-- Schritt 1: Inbetriebnahme -->
  <mat-form-field appearance="outline" class="auswahl">
    <mat-label>Inbetriebnahme</mat-label>
    <mat-select [value]="inbetriebnahmeId" (selectionChange)="onInbetriebnahmeChange($event.value)">
      <mat-option *ngFor="let inb of inbetriebnahmen" [value]="inb.id">
        {{ inb.name }} ({{ inb.messstellenCount }} Messstellen)
      </mat-option>
    </mat-select>
    <mat-hint *ngIf="inbetriebnahmeId == null">
      Die Messstellen werden innerhalb einer Inbetriebnahme ausgewählt.
    </mat-hint>
  </mat-form-field>


  <p class="fehler" *ngIf="ladeFehler">
    <mat-icon>error_outline</mat-icon>
    {{ ladeFehler }}
  </p>

  <div class="laden" *ngIf="ladeMessstellen">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <span>Messstellen werden geladen …</span>
  </div>


  <ng-container *ngIf="inbetriebnahmeId != null && !ladeMessstellen && !ladeFehler">

    <!-- Schritt 2: Filter -->
    <div class="filter">

      <mat-form-field appearance="outline" class="filter-suche">
        <mat-label>Suche</mat-label>
        <input matInput [(ngModel)]="suche" (ngModelChange)="aktualisiereTreffer()"
          [placeholder]="kennzeichnungTitel + ' oder Langtext'">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <!-- Alle Auswahlwerte stammen aus den Messstellen dieser Inbetriebnahme. -->
      <mat-form-field appearance="outline" class="filter-feld" *ngIf="zeigeAnlagenteilFilter">
        <mat-label>Anlagenteil</mat-label>
        <mat-select [(ngModel)]="filterAnlagenteil" (ngModelChange)="aktualisiereTreffer()">
          <mat-option value="">Alle</mat-option>
          <mat-option value="__keiner__" *ngIf="filterOptionen.hatOhneAnlagenteil">
            Ohne Anlagenteil
          </mat-option>
          <mat-option *ngFor="let a of filterOptionen.anlagenteile" [value]="a.id.toString()">
            {{ a.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-feld" *ngIf="zeigeKategorieFilter">
        <mat-label>Kategorie</mat-label>
        <mat-select [(ngModel)]="filterKategorie" (ngModelChange)="aktualisiereTreffer()">
          <mat-option value="">Alle</mat-option>
          <mat-option value="__keine__" *ngIf="filterOptionen.hatOhneKategorie">
            Ohne Kategorie
          </mat-option>
          <mat-option *ngFor="let k of filterOptionen.kategorien" [value]="k">{{ k }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-feld" *ngIf="zeigeSignalStatusFilter">
        <mat-label>Signalstatus</mat-label>
        <mat-select [(ngModel)]="filterSignalStatus" (ngModelChange)="aktualisiereTreffer()">
          <mat-option value="">Alle</mat-option>
          <mat-option *ngFor="let o of filterOptionen.signalStatus" [value]="o.wert.toString()">
            {{ o.text }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-feld" *ngIf="zeigePruefergebnisFilter">
        <mat-label>Prüfergebnis</mat-label>
        <mat-select [(ngModel)]="filterPruefergebnis" (ngModelChange)="aktualisiereTreffer()">
          <mat-option value="">Alle</mat-option>
          <mat-option *ngFor="let o of filterOptionen.pruefergebnis" [value]="o.wert.toString()">
            {{ o.text }}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>


    <!-- Schritt 3: Treffer -->
    <div class="treffer-kopf">

      <span class="treffer-anzahl">
        {{ treffer.length }} von {{ alle.length }} Messstellen
        <span class="treffer-hinweis" *ngIf="!hatFilter">· kein Filter gesetzt</span>
      </span>

      <span class="treffer-aktionen">
        <button mat-button type="button" *ngIf="hatFilter" (click)="setzeFilterZurueck()">
          Filter zurücksetzen
        </button>
        <button mat-stroked-button color="primary" type="button" [disabled]="offeneTreffer === 0"
          (click)="alleAngezeigtenHinzufuegen()">
          <mat-icon>playlist_add</mat-icon>
          Alle angezeigten hinzufügen<span *ngIf="offeneTreffer > 0"> ({{ offeneTreffer }})</span>
        </button>
      </span>

    </div>

    <div class="treffer-liste">

      <p class="leer" *ngIf="treffer.length === 0">
        Keine Messstelle passt zu diesem Filter.
      </p>

      <button type="button" class="messstelle-zeile" *ngFor="let m of treffer; trackBy: spurId"
        [class.gewaehlt]="istGewaehlt(m)" [disabled]="istGewaehlt(m)" (click)="hinzufuegen(m)"
        [attr.aria-label]="'Messstelle ' + anzeigeName(m) + ' zur Exportliste hinzufügen'">

        <mat-icon class="zeile-icon">{{ istGewaehlt(m) ? 'check_circle' : 'add_circle_outline' }}</mat-icon>

        <span class="zeile-text">

          <span class="zeile-kopf">
            <span class="messstelle-status" [ngClass]="statusCss(m)">{{ statusText(m) }}</span>
            <span class="messstelle-ergebnis" [ngClass]="ergebnisCss(m)">{{ ergebnisText(m) }}</span>
            <span class="messstelle-kennzeichnung">{{ anzeigeName(m) }}</span>
          </span>

          <span class="zeile-langtext" [class.leer-text]="!m.langtext">
            {{ m.langtext || 'Kein Langtext vorhanden' }}
          </span>

          <span class="zeile-meta" *ngIf="m.anlagenteilName || m.kategorieName">
            <span *ngIf="m.anlagenteilName">{{ m.anlagenteilName }}</span>
            <span *ngIf="m.anlagenteilName && m.kategorieName"> · </span>
            <span *ngIf="m.kategorieName">{{ m.kategorieName }}</span>
          </span>

        </span>

      </button>

    </div>


    <!-- Schritt 4: Exportliste -->
    <div class="exportliste">

      <div class="exportliste-kopf">
        <span class="exportliste-titel">
          Exportliste · {{ exportliste.length }} Messstelle{{ exportliste.length === 1 ? '' : 'n' }}
        </span>
        <button mat-button type="button" [disabled]="exportliste.length === 0" (click)="leeren()">
          <mat-icon>delete_sweep</mat-icon>
          Liste leeren
        </button>
      </div>

      <p class="leer" *ngIf="exportliste.length === 0">
        Noch keine Messstelle ausgewählt. Oben einzeln hinzufügen oder alle
        angezeigten übernehmen.
      </p>

      <ol class="exportliste-eintraege" *ngIf="exportliste.length > 0">
        <li *ngFor="let m of exportliste; trackBy: spurId">
          <span class="export-kennzeichnung">{{ anzeigeName(m) }}</span>
          <span class="export-langtext" *ngIf="m.langtext"> · {{ m.langtext }}</span>
          <button mat-button type="button" class="entfernen" (click)="entfernen(m)"
            [attr.aria-label]="'Messstelle ' + anzeigeName(m) + ' aus der Exportliste entfernen'">
            entfernen
          </button>
        </li>
      </ol>

    </div>

  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="abbrechen()">Abbrechen</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!istGueltig" (click)="exportieren()">
    <mat-icon>{{ exportButtonIcon }}</mat-icon>
    {{ exportButtonText }}
  </button>
</mat-dialog-actions>
